import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AccountMenu from './AccountMenu';
import './Sidebar.css';

// Plan-independent rail: every plan sees the same items, so the rail can
// never overflow. Plan-gated features live in the Company hub (/more),
// which badges and upsells locked ones; role gating still applies here.
const NAV = [
  { to: '/products',   icon: '📦', label: 'Products',  managerOnly: true },
  { to: '/customers',  icon: '👥', label: 'Customers', perm: 'view_customers' },
  { to: '/financials', icon: '📊', label: 'Reports',   managerOnly: true },
  { to: '/more',       icon: '🏢', label: 'Company',   managerOnly: true },
];

export default function Sidebar() {
  const { user, isEnterprise, hasPermission } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const homeLink = (isEnterprise && user?.role === 'owner') ? '/company' : '/dashboard';
  const isManager = user?.role === 'owner' || user?.role === 'manager';

  // Close sidebar on route change (mobile nav)
  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <>
      {/* Hamburger — mobile only */}
      <button
        className="sidebar-hamburger"
        onClick={() => setOpen(o => !o)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>

      {/* Backdrop — mobile only, shown when open */}
      {open && <div className="sidebar-backdrop" onClick={() => setOpen(false)} />}

      <aside className={`sidebar${open ? ' sidebar-open' : ''}`}>
        <NavLink to={homeLink} title="Home" aria-label="Home" className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}>
          <span className="sidebar-icon">🏠</span>
          <span className="sidebar-label">Home</span>
        </NavLink>

        <div className="sidebar-top">
          <div className="sidebar-divider" />
          {NAV.filter(item => (!item.managerOnly || isManager) && (!item.perm || hasPermission(item.perm))).map(item => (
            <NavLink key={item.to} to={item.to} title={item.label} aria-label={item.label} className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}>
              <span className="sidebar-icon">{item.icon}</span>
              <span className="sidebar-label">{item.label}</span>
            </NavLink>
          ))}
        </div>

        <div className="sidebar-bottom">
          <AccountMenu />
        </div>
      </aside>
    </>
  );
}
